'use strict';

import template from './location_search_predictions.html';

const DEFAULT_CONTAINER_CSS = {
  background: 'white',
  display: 'none',
  position: 'absolute',
  'z-index': '2000'
};
const saLocationSearchPredictions = [
  '$window',
  'scrollTop',

  function ($window, scrollTop) {
    return {
      template: template,
      replace: true,
      scope: {
        predictions: '=',
        input: '=',
        selectedPrediction: '='
      },
      bindToController: true,
      controllerAs: 'ctrl',
      controller: [
        function () {}
      ],
      link: function ($scope, $element) {
        var windowEl = angular.element($window);

        function positionContainer() {
          var input = $scope.ctrl.input;
          var inputElement = input[0];
          var rect = inputElement.getBoundingClientRect();

          angular.extend($scope.css, {
            top: String(rect.top + rect.height + scrollTop()) + 'px',
            left: String(rect.left) + 'px',
            width: String(rect.width) + 'px'
          });
        }

        function eventHandler() {
          $scope.$apply(function () {
            if ($scope.css.display !== 'none') {
              positionContainer();
            }
          });
        }

        function removeEventHandlers() {
          windowEl.off('resize', eventHandler);
          windowEl.off('scroll', eventHandler);
        }

        $scope.css = angular.copy(DEFAULT_CONTAINER_CSS);

        $scope.$watch('ctrl.predictions.length', function (length) {
          if (length && document.activeElement === $scope.ctrl.input[0]) {
            positionContainer();
            $scope.css.display = 'block';
            windowEl.on('resize', eventHandler);
            windowEl.on('scroll', eventHandler);
          } else {
            removeEventHandlers();
            $scope.css.display = 'none';
          }
        });

        $element.on('$destroy', function () {
          removeEventHandlers();
        });
      }
    };
  }
];

export default saLocationSearchPredictions;



// WEBPACK FOOTER //
// ./app/src/common/location_search/location_search_predictions.js